import { render, staticRenderFns } from "./itemReports.vue?vue&type=template&id=fe82c09c&"
import script from "./itemReports.vue?vue&type=script&lang=js&"
export * from "./itemReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports